module.exports = __webpack_public_path__ + "files/473aaf20b0fad96d06051986568c0a33.png";